__turbopack_context__.v({
  "close-icon": "Toast-module-scss-module__X6F3_W__close-icon",
  "is-fixed": "Toast-module-scss-module__X6F3_W__is-fixed",
  "splitWarning": "Toast-module-scss-module__X6F3_W__splitWarning",
  "toast-container": "Toast-module-scss-module__X6F3_W__toast-container",
  "toast-content": "Toast-module-scss-module__X6F3_W__toast-content",
  "toast-content-inner": "Toast-module-scss-module__X6F3_W__toast-content-inner",
  "toast-text": "Toast-module-scss-module__X6F3_W__toast-text",
});
